/**
 * Split snake_case `event_type` into space-separated English words with title case
 * (e.g. `rating_pillar_rank_changed` → "Rating Pillar Rank Changed").
 */
export function formatNotificationSignalHeaderEventTypeLabel(
  eventType: string,
): string {
  const raw = eventType.trim();
  if (!raw) {
    return "";
  }
  return raw
    .split("_")
    .filter((segment) => segment.length > 0)
    .map((segment) => {
      const lower = segment.toLowerCase();
      return lower.charAt(0).toUpperCase() + lower.slice(1);
    })
    .join(" ");
}
